
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("7UfvE"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("7UfvE", function(module, exports) {

let $5c19cb37720563a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5c19cb37720563a4$var$load("hxlaf"),
    $5c19cb37720563a4$var$load("7FEF1"),
    $5c19cb37720563a4$var$load("1F7LX"),
    $5c19cb37720563a4$var$load("jZLnv"),
    $5c19cb37720563a4$var$load("6edij"),
    $5c19cb37720563a4$var$load("hXbzh"),
    $5c19cb37720563a4$var$load("gknbb"),
    $5c19cb37720563a4$var$load("6iz6l"),
    $5c19cb37720563a4$var$load("4SCW2"),
    $5c19cb37720563a4$var$load("36QeB"),
    $5c19cb37720563a4$var$load("9q75n"),
    $5c19cb37720563a4$var$load("iYHbd"),
    $5c19cb37720563a4$var$load("2jJ1i"),
    $5c19cb37720563a4$var$load("bd77Q"),
    $5c19cb37720563a4$var$load("hnGEQ"),
    $5c19cb37720563a4$var$load("dek7I"),
    $5c19cb37720563a4$var$load("6SWFK"),
    $5c19cb37720563a4$var$load("9aQIt"),
    $5c19cb37720563a4$var$load("5zapo"),
    $5c19cb37720563a4$var$load("3MYQs"),
    $5c19cb37720563a4$var$load("XZauT"),
    $5c19cb37720563a4$var$load("4S1SF"),
    $5c19cb37720563a4$var$load("jiFtb"),
    $5c19cb37720563a4$var$load("lm9Lt"),
    $5c19cb37720563a4$var$load("9atVd"),
    $5c19cb37720563a4$var$load("9wPDc"),
    $5c19cb37720563a4$var$load("1MWOL"),
    $5c19cb37720563a4$var$load("6fQco"),
    $5c19cb37720563a4$var$load("dYtBN"),
    $5c19cb37720563a4$var$load("kNV5Y"),
    $5c19cb37720563a4$var$load("aOY32"),
    $5c19cb37720563a4$var$load("7jSfd"),
    $5c19cb37720563a4$var$load("4HZlX"),
    $5c19cb37720563a4$var$load("6wr18"),
    $5c19cb37720563a4$var$load("kDqHr"),
    $5c19cb37720563a4$var$load("jPuvo"),
    $5c19cb37720563a4$var$load("3GuOt"),
    $5c19cb37720563a4$var$load("7EorR"),
    $5c19cb37720563a4$var$load("ffEVr"),
    $5c19cb37720563a4$var$load("1eitL"),
    $5c19cb37720563a4$var$load("e4lCF"),
    $5c19cb37720563a4$var$load("kuFG2"),
    $5c19cb37720563a4$var$load("Wowvf"),
    $5c19cb37720563a4$var$load("hhss7"),
    $5c19cb37720563a4$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("jDpCh"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("jDpCh", function(module, exports) {

let $e4b587b517739738$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4b587b517739738$var$load("6wr18"),
    $e4b587b517739738$var$load("ffEVr"),
    $e4b587b517739738$var$load("ld7XK"),
    $e4b587b517739738$var$load("rvNVc"),
    $e4b587b517739738$var$load("1eitL"),
    $e4b587b517739738$var$load("e4lCF"),
    $e4b587b517739738$var$load("kuFG2"),
    $e4b587b517739738$var$load("1F7LX"),
    $e4b587b517739738$var$load("hXbzh"),
    $e4b587b517739738$var$load("hhss7"),
    $e4b587b517739738$var$load("h3ABO"),
    $e4b587b517739738$var$load("kC80R"),
    $e4b587b517739738$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("erKSJ"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("erKSJ", function(module, exports) {

let $a847f40f72b8656c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a847f40f72b8656c$var$load("5stRu"),
    $a847f40f72b8656c$var$load("f0c8J"),
    $a847f40f72b8656c$var$load("cyGuT"),
    $a847f40f72b8656c$var$load("b9CA3"),
    $a847f40f72b8656c$var$load("2YffH"),
    $a847f40f72b8656c$var$load("fgeQY"),
    $a847f40f72b8656c$var$load("9phg9"),
    $a847f40f72b8656c$var$load("kkxT0"),
    $a847f40f72b8656c$var$load("xu7ej"),
    $a847f40f72b8656c$var$load("iQ4FP"),
    $a847f40f72b8656c$var$load("3EXzu"),
    $a847f40f72b8656c$var$load("im1VN"),
    $a847f40f72b8656c$var$load("blwYk"),
    $a847f40f72b8656c$var$load("czd3n"),
    $a847f40f72b8656c$var$load("38CGl"),
    $a847f40f72b8656c$var$load("9GoYI"),
    $a847f40f72b8656c$var$load("huPEO"),
    $a847f40f72b8656c$var$load("6CD7h"),
    $a847f40f72b8656c$var$load("j9Q0e"),
    $a847f40f72b8656c$var$load("71gca"),
    $a847f40f72b8656c$var$load("fp8oP"),
    $a847f40f72b8656c$var$load("4oXMS"),
    $a847f40f72b8656c$var$load("gnDXu"),
    $a847f40f72b8656c$var$load("4Ok6H"),
    $a847f40f72b8656c$var$load("eL33A"),
    $a847f40f72b8656c$var$load("2B2rM"),
    $a847f40f72b8656c$var$load("b11Cj"),
    $a847f40f72b8656c$var$load("7bkye"),
    $a847f40f72b8656c$var$load("9anPW"),
    $a847f40f72b8656c$var$load("fAtWn"),
    $a847f40f72b8656c$var$load("iPYAE"),
    $a847f40f72b8656c$var$load("6iz6l"),
    $a847f40f72b8656c$var$load("4SCW2"),
    $a847f40f72b8656c$var$load("9q75n"),
    $a847f40f72b8656c$var$load("iYHbd"),
    $a847f40f72b8656c$var$load("2jJ1i"),
    $a847f40f72b8656c$var$load("bd77Q"),
    $a847f40f72b8656c$var$load("hxlaf"),
    $a847f40f72b8656c$var$load("7FEF1"),
    $a847f40f72b8656c$var$load("8EEwj"),
    $a847f40f72b8656c$var$load("b2FtX"),
    $a847f40f72b8656c$var$load("c0JsV"),
    $a847f40f72b8656c$var$load("h3ABO"),
    $a847f40f72b8656c$var$load("coUzl"),
    $a847f40f72b8656c$var$load("5nMTY"),
    $a847f40f72b8656c$var$load("1eitL"),
    $a847f40f72b8656c$var$load("e4lCF"),
    $a847f40f72b8656c$var$load("6wr18"),
    $a847f40f72b8656c$var$load("rqZ7Q"),
    $a847f40f72b8656c$var$load("4Qe0Q"),
    $a847f40f72b8656c$var$load("Wowvf"),
    $a847f40f72b8656c$var$load("9DBoM"),
    $a847f40f72b8656c$var$load("ffEVr"),
    $a847f40f72b8656c$var$load("ld7XK"),
    $a847f40f72b8656c$var$load("rvNVc"),
    $a847f40f72b8656c$var$load("1F7LX"),
    $a847f40f72b8656c$var$load("hXbzh"),
    $a847f40f72b8656c$var$load("jnVKv"),
    $a847f40f72b8656c$var$load("7EorR"),
    $a847f40f72b8656c$var$load("bgHzk"),
    $a847f40f72b8656c$var$load("hhss7"),
    $a847f40f72b8656c$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.d6621379.js.map
